import React from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import  Cabecera  from '../Cabecera/index_365';
import  BotonTriger from '../Botones/botonTrige';
import Grid from '@material-ui/core/Grid';
import { withAuthorization } from '../Session';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import Copyright from '../Privacidad/copyright';
const medidas= '20%';
const images = [
  {
    url: 'https://source.unsplash.com/featured/?building,home',
    title: 'COMUNIDADES',
    width: medidas,
    href:ROUTES.COMUNIDADES
  },
  {
    url: 'https://source.unsplash.com/featured/?supplier',
    title: 'GREMIOS',
    width: medidas,
    href: ROUTES.GREMIOS

  },
  {
    url: 'https://source.unsplash.com/featured/?meeting,space',
    title: 'ZONAS COMUNES',
    width: medidas,
    href: ROUTES.ZONAS

  },
  {
    url: 'https://source.unsplash.com/featured/?maintenance,home',
    title: 'ACTIVIDADES',
    width: medidas,
    href: ROUTES.ACTIVIDADES

  },

  {
    url: 'https://source.unsplash.com/featured/?data',
    title: 'CATEGORÍAS',
    width: medidas,
    href: ROUTES.CATEGORIAS

  },
  {
    url: 'https://source.unsplash.com/featured/?users,data',
    title: 'USUARIOS',
    width: medidas,
    href: ROUTES.USUARIOS

  },
  {
    url: 'https://source.unsplash.com/featured/?profile',
    title: 'ROLES',
    width: medidas,
    href: ROUTES.ROLES

  },
];


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 300,
    width: '100%',
  },
  image: {
    position: 'relative',
    height: 200,
    [theme.breakpoints.down('xs')]: {
      width: '50%', // Overrides inline-style
      height: 100,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
}));


function DatosMaestros() {
  const classes = useStyles();

  return (
    <Grid >   <Cabecera/>    <hr/>  <BotonTriger/>
    <Grid  container   direction="row"  justify="space-around"  alignItems="center">
      {images.map(image => (
        <ButtonBase href={image.href}
          focusRipple
          key={image.title}
          className={classes.image}
          focusVisibleClassName={classes.focusVisible}
          style={{
            width: image.width,  margin: 10
          }}
        >
          <span
            className={classes.imageSrc}
            style={{
              backgroundImage: `url(${image.url})`,
            }}
          />
          <span className={classes.imageBackdrop} />
          <span className={classes.imageButton}>
            <Typography
              component="span"
              variant="subtitle1"
              color="inherit"
              className={classes.imageTitle}
            >
              {image.title}
              <span className={classes.imageMarked} />
            </Typography>
          </span>
        </ButtonBase>
      ))}
      </Grid>

      <Box mt={6}>
              <Copyright />
            </Box>
    </Grid>
  );
}

const condition = authUser => !!authUser;
export default  withRouter (withFirebase (withAuthorization(condition)(DatosMaestros)));